/* global ol */

var point = require('./util').point;
var style = require('./style');

function PickupLocationLayer(pickupLocation) {
  this.pickupLocation = pickupLocation;

  this.layer = new ol.layer.Vector({
    source: new ol.source.Vector({
      features: [this.initFeature()]
    }),
    style: style.bind(null, {
      radius: 11,
      color: 'black',
      text: 'S'
    }),
    updateWhileAnimating: true,
    updateWhileInteracting: true,
    renderBuffer: 22
  });
}

PickupLocationLayer.prototype.initFeature = function() {
  var feature = new ol.Feature();

  feature.setGeometry(point(this.pickupLocation));
  feature.set('pickupLocation', this.pickupLocation, true);
  feature.set('layer', this, true);

  return feature;
};

module.exports = PickupLocationLayer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/pickupLocationLayer.js
 ** module id = 186
 ** module chunks = 1
 **/